var _defs, _path, _path2, _text, _text2, _text3, _text4, _path3, _text5, _text6, _text7, _g, _g2, _path4, _g3, _g4, _path5, _g5, _text8, _path6, _text9, _path7, _text10, _path8, _text11, _path9, _text12, _path10, _text13, _path11, _text14, _path12, _text15, _path13, _text16, _path14, _text17, _text18, _text19, _text20, _path15, _text21, _path16, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _path17, _path18, _path19, _g6, _text34, _path20, _text35, _text36, _g7, _text37, _text38, _path21, _g8, _text39, _text40, _path22, _g9, _text41, _path23, _g10, _text42, _path24, _path25, _text43, _path26, _path27, _text44, _text45, _text46, _path28, _path29, _text47, _text48, _text49, _path30, _path31, _text50, _text51, _path32, _text52, _path33, _text53, _g11, _text54, _path34, _path35, _path36, _path37, _path38, _text55, _text56, _g12, _g13, _g14, _text57, _path39, _path40, _text58, _path41, _path42, _text59, _text60, _text61, _path43, _path44, _text62, _text63, _text64, _path45, _path46, _text65, _text66, _path47, _text67, _path48, _text68, _g15, _text69, _path49, _path50, _path51, _path52, _path53, _text70, _text71, _text72, _path54, _text73, _g16, _g17, _g18, _g19, _path55, _path56, _g20, _path57, _g21, _path58, _text74, _g22, _g23, _g24, _text75, _path59, _path60, _g25, _path61;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResQSlider3 = function SvgResQSlider3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 922 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "resQ_Slider3_svg__a",
    x1: 0.979,
    x2: 0.012,
    y1: 0.049,
    y2: 0.947,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5893f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resQ_Slider3_svg__b",
    x1: 0.978,
    x2: 0.012,
    y1: 0.036,
    y2: 0.969,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d55a86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a9548f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resQ_Slider3_svg__h",
    x1: 0.527,
    x2: 0.53,
    y2: 1.078,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feda00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#fdada8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f05a5c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "resQ_Slider3_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h125.271v14.476H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "resQ_Slider3_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h122.274v13.476H0Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h920v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M0 80h920v400H0z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 12,
    fontWeight: 300,
    transform: "translate(809 158)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "McDonalds Survey"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "#848484",
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 12,
    fontWeight: 300,
    transform: "translate(717 158)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dashboard"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    fill: "#989898",
    fontFamily: "TeluguMN-Bold, Telugu MN",
    fontSize: 15,
    fontWeight: 700,
    transform: "translate(794 158)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    fill: "#ed595b",
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 14,
    fontWeight: 300,
    transform: "translate(0 155)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dashboard"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#000"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed595b",
    d: "M1 163h83v1H1z"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 14,
    fontWeight: 300,
    transform: "translate(120 155)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "resQ Settings"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 14,
    fontWeight: 300,
    transform: "translate(249 155)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Share Project"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 14,
    fontWeight: 300,
    transform: "translate(378 155)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Reports & Downloads"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#resQ_Slider3_svg__a)",
    stroke: "#f1744b",
    transform: "translate(727 174)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 68,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 67,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 11,
    transform: "translate(737 195)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Total Responses ")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 22,
    fontWeight: 600,
    transform: "translate(737 225)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1000")))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M877.904 191.743a7.3 7.3 0 0 0-9.771 0 6.073 6.073 0 0 0 0 9.051 7.3 7.3 0 0 0 9.771 0 6.073 6.073 0 0 0 0-9.051m22.858 33.867a.75.75 0 0 1 .779-.722h.283a2.18 2.18 0 0 0 1.481-.571 1.87 1.87 0 0 0 .617-1.372v-11.219a1.87 1.87 0 0 0-.617-1.372 2.18 2.18 0 0 0-1.481-.571h-21.385a2.18 2.18 0 0 0-1.481.571 1.87 1.87 0 0 0-.617 1.372v11.219a1.87 1.87 0 0 0 .617 1.372 2.18 2.18 0 0 0 1.481.571h15.33a.8.8 0 0 1 .361.082l.012.006.013.007.012.007.012.007.01.006h.007l.029.02.015.011a1 1 0 0 1 .063.054l4.459 4.129zm-36.038 4.669h-3.849v-22.5a3.52 3.52 0 0 1 1.162-2.586 4.1 4.1 0 0 1 2.792-1.076h16.38a4.1 4.1 0 0 1 2.792 1.076 3.52 3.52 0 0 1 1.161 2.582v.564h-4.722a3.8 3.8 0 0 0-2.584.994 3.26 3.26 0 0 0-1.074 2.393v11.218a3.26 3.26 0 0 0 1.074 2.393 3.8 3.8 0 0 0 2.584.994h4.722v3.947h-18.879v-10.749a.782.782 0 0 0-1.559 0zm24.263-14.231a.685.685 0 0 1 0 1.021.825.825 0 0 1-1.1 0l-2.213-2.05-.023-.019-.012-.012-.01-.01-.012-.014-.025-.035-.007-.011-.021-.035v-.019l-.007-.014a.67.67 0 0 1 0-.543l.007-.015.007-.013v-.01l.021-.035.007-.011.025-.035.012-.014h.015l.008-.008-.006-.166h.009l.007-.006h.007l2.215-2.052a.825.825 0 0 1 1.1 0 .685.685 0 0 1 0 1.021l-.889.824h3.884a5.03 5.03 0 0 1 3.426 1.319 4.32 4.32 0 0 1 1.424 3.173v3.953a.782.782 0 0 1-1.559 0v-3.969a2.93 2.93 0 0 0-.967-2.152 3.41 3.41 0 0 0-2.323-.9h-3.881l.889.824Zm17.275-28.96a12.03 12.03 0 0 0-16.095 0 10 10 0 0 0 0 14.909 12.03 12.03 0 0 0 16.095.003 10 10 0 0 0 0-14.909Zm-8.044-2.313a10.95 10.95 0 0 1 7.456 2.861 9.266 9.266 0 0 1 0 13.813 11.146 11.146 0 0 1-14.912 0 9.266 9.266 0 0 1 0-13.813 10.95 10.95 0 0 1 7.456-2.861m.366 9.428a.456.456 0 0 1 0 .679.55.55 0 0 1-.733 0 .456.456 0 0 1 0-.679.55.55 0 0 1 .733 0M894.413 187a9.5 9.5 0 0 1 3.025-.75v1.1a.782.782 0 0 0 1.559 0v-1.1a9.5 9.5 0 0 1 3.024.75l-.593.951a.69.69 0 0 0 .283.984.81.81 0 0 0 1.062-.262l.593-.952a9 9 0 0 1 1.2.936 8.6 8.6 0 0 1 1.011 1.116l-1.026.549a.69.69 0 0 0-.286.982.81.81 0 0 0 1.06.265l1.03-.551a7.8 7.8 0 0 1 .809 2.8h-1.18a.724.724 0 1 0 0 1.444h1.185a7.8 7.8 0 0 1-.809 2.8l-1.027-.549a.81.81 0 0 0-1.062.262.69.69 0 0 0 .283.984l1.028.55a8.6 8.6 0 0 1-1.01 1.115 9 9 0 0 1-1.205.937l-.592-.95a.81.81 0 0 0-1.06-.265.69.69 0 0 0-.286.982l.595.954a9.5 9.5 0 0 1-3.025.75v-1.1a.782.782 0 0 0-1.559 0v1.1a9.5 9.5 0 0 1-3.024-.749l.593-.951a.69.69 0 0 0-.283-.984.81.81 0 0 0-1.062.262l-.593.952a9 9 0 0 1-1.2-.936 8.6 8.6 0 0 1-1.011-1.116l1.026-.549a.69.69 0 0 0 .286-.982.81.81 0 0 0-1.06-.265l-1.03.551a7.8 7.8 0 0 1-.809-2.8h1.179a.724.724 0 1 0 0-1.444h-1.19a7.8 7.8 0 0 1 .809-2.8l1.027.549a.81.81 0 0 0 1.062-.262.69.69 0 0 0-.283-.984l-1.028-.55a8.6 8.6 0 0 1 1.013-1.117 9 9 0 0 1 1.205-.937l.592.95a.81.81 0 0 0 1.06.265.69.69 0 0 0 .286-.982zm1.879 8.264h-2.437a.724.724 0 1 1 0-1.444h2.437a1.9 1.9 0 0 1 .457-.639 2.2 2.2 0 0 1 2.938 0 1.826 1.826 0 0 1 0 2.721 2.1 2.1 0 0 1-.689.424v1.661a.782.782 0 0 1-1.559 0v-1.66a2.1 2.1 0 0 1-.689-.424 1.9 1.9 0 0 1-.457-.639Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#resQ_Slider3_svg__b)",
    stroke: "#c5588a",
    transform: "translate(727 249)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 70,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 69,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 11,
    transform: "translate(737 274)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Disqualified")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-ExtraBold, Poppins",
    fontSize: 22,
    fontWeight: 800,
    transform: "translate(737 304)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "823")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M907.61 288.529a1.2 1.2 0 0 0-.393-.873l-1.311-1.207a1.44 1.44 0 0 0-1.895 0l-.6.554a8 8 0 0 0-.675-.243v-.785a1.2 1.2 0 0 0-.4-.881 1.4 1.4 0 0 0-.956-.364h-1.812a1.3 1.3 0 0 0-1.352 1.245v.8a5 5 0 0 0-.629.255l-.621-.579a1.436 1.436 0 0 0-1.892 0l-1.352 1.207a1.17 1.17 0 0 0 0 1.745l.616.554a4.5 4.5 0 0 0-.256.624h-.819a1.3 1.3 0 0 0-1.357 1.239v1.707a1.2 1.2 0 0 0 .4.881 1.42 1.42 0 0 0 .956.364h.825a5 5 0 0 0 .284.624l-.6.542a1.175 1.175 0 0 0 0 1.745l1.352 1.207a1.44 1.44 0 0 0 1.895 0l.54-.516a5 5 0 0 0 .677.262v.729a1.2 1.2 0 0 0 .4.881 1.42 1.42 0 0 0 .956.364h1.856a1.4 1.4 0 0 0 .956-.364 1.2 1.2 0 0 0 .4-.881v-.7a4 4 0 0 0 .662-.343l.548.5a1.434 1.434 0 0 0 1.895 0l1.309-1.202a1.2 1.2 0 0 0 .393-.871 1.16 1.16 0 0 0-.393-.873l-.548-.493a5 5 0 0 0 .284-.661h.784a1.4 1.4 0 0 0 .956-.364 1.2 1.2 0 0 0 .4-.881v-1.7a1.2 1.2 0 0 0-.4-.881 1.4 1.4 0 0 0-.956-.364h-.8a5 5 0 0 0-.3-.624l.581-.535a1.2 1.2 0 0 0 .393-.852Zm-7.116 8.158a4.41 4.41 0 0 1-4.06-2.5 3.82 3.82 0 0 1 .954-4.412 4.68 4.68 0 0 1 4.791-.878 4.07 4.07 0 0 1 2.708 3.743 4.233 4.233 0 0 1-4.4 4.048Zm3.043-4.047a2.81 2.81 0 0 1-1.877 2.588 3.24 3.24 0 0 1-3.317-.607 2.64 2.64 0 0 1-.659-3.055 3.05 3.05 0 0 1 2.81-1.728 2.936 2.936 0 0 1 3.018 2.8Zm-35.871 0a2.81 2.81 0 0 1-1.879 2.59 3.24 3.24 0 0 1-3.317-.612 2.64 2.64 0 0 1-.657-3.055 3.06 3.06 0 0 1 2.818-1.726 2.927 2.927 0 0 1 3.036 2.8Zm4.2 2.086a1.4 1.4 0 0 0 .956-.364 1.2 1.2 0 0 0 .4-.881v-1.7a1.2 1.2 0 0 0-.4-.881 1.4 1.4 0 0 0-.956-.364h-.817a4 4 0 0 0-.3-.624l.581-.535a1.15 1.15 0 0 0 .391-.871 1.2 1.2 0 0 0-.385-.873l-1.319-1.207a1.436 1.436 0 0 0-1.892 0l-.588.554a6 6 0 0 0-.677-.243v-.766a1.2 1.2 0 0 0-.4-.881 1.42 1.42 0 0 0-.956-.364h-1.84a1.3 1.3 0 0 0-1.354 1.245v.8a4.4 4.4 0 0 0-.629.255l-.629-.579a1.436 1.436 0 0 0-1.892 0l-1.311 1.207a1.18 1.18 0 0 0 0 1.745l.616.554a4.5 4.5 0 0 0-.264.624h-.845A1.3 1.3 0 0 0 856 291.82v1.707a1.2 1.2 0 0 0 .4.881 1.4 1.4 0 0 0 .956.364h.845a4.4 4.4 0 0 0 .284.624l-.588.542a1.18 1.18 0 0 0 0 1.745l1.311 1.207a1.44 1.44 0 0 0 1.895 0l.548-.516a4.6 4.6 0 0 0 .677.262v.729a1.2 1.2 0 0 0 .4.881 1.42 1.42 0 0 0 .956.364h1.859a1.4 1.4 0 0 0 .956-.364 1.2 1.2 0 0 0 .4-.881v-.7a4 4 0 0 0 .675-.343l.548.5a1.435 1.435 0 0 0 1.887 0l1.301-1.202a1.18 1.18 0 0 0 0-1.745l-.555-.493a3.6 3.6 0 0 0 .292-.661Zm-7.236 1.962a4.42 4.42 0 0 1-4.065-2.494 3.82 3.82 0 0 1 .948-4.414 4.68 4.68 0 0 1 4.791-.881 4.06 4.06 0 0 1 2.716 3.742 3.9 3.9 0 0 1-1.3 2.868 4.6 4.6 0 0 1-3.122 1.179Zm.332-25.143h35.572a3.006 3.006 0 0 1 2.993 2.887 3.007 3.007 0 0 1-2.993 2.888h-35.572a3.007 3.007 0 0 1-2.993-2.887 3.006 3.006 0 0 1 2.993-2.887Zm4.39-5.276a2.9 2.9 0 0 1-2.66-1.637 2.5 2.5 0 0 1 .624-2.891 3.07 3.07 0 0 1 3.14-.577 2.66 2.66 0 0 1 1.775 2.456 2.77 2.77 0 0 1-2.861 2.66Zm11.95-.852a2.89 2.89 0 0 1 2.663 1.637 2.5 2.5 0 0 1-.624 2.891 3.06 3.06 0 0 1-3.14.575 2.66 2.66 0 0 1-1.78-2.45 2.56 2.56 0 0 1 .855-1.88 3.02 3.02 0 0 1 2.047-.768Zm11.95-1.8a2.66 2.66 0 0 1-1.788 2.448 3.06 3.06 0 0 1-3.14-.586 2.51 2.51 0 0 1-.609-2.9 2.9 2.9 0 0 1 2.672-1.624 3 3 0 0 1 2.042.782 2.54 2.54 0 0 1 .839 1.885Zm3.51 2.653a.65.65 0 0 1-.675-.624v-3.663a.678.678 0 0 1 1.352 0v3.669a.65.65 0 0 1-.657.624Zm-2.658.474v3.669a.678.678 0 0 1-1.352 0v-3.666a.678.678 0 0 1 1.352 0Zm-12.017-7.606a.7.7 0 0 1 .477.182.6.6 0 0 1 .2.439v3.688a.678.678 0 0 1-1.352 0v-3.688a.65.65 0 0 1 .677-.621Zm-8.794 11.391a.65.65 0 0 1-.677-.624v-3.667a.679.679 0 0 1 1.354 0v3.667a.6.6 0 0 1-.208.451.72.72 0 0 1-.5.173Zm1.61 22.228v-1.8a5.45 5.45 0 0 0-1.316-3.507l-7.616-8.88h33.576l-7.588 8.88a5.38 5.38 0 0 0-1.352 3.508v1.8l-.806-.743a2.9 2.9 0 0 0-1.968-.74 3.06 3.06 0 0 0-1.352.318 2.76 2.76 0 0 0-2.706-1.873h-2.082a2.76 2.76 0 0 0-2.706 1.873 2.96 2.96 0 0 0-1.352-.325 2.9 2.9 0 0 0-1.968.754Zm15.243 9.463h.893a1.393 1.393 0 0 0 1.441-1.327v-1.945a1.385 1.385 0 0 0-1.441-1.32h-.933a.08.08 0 0 1-.074-.051 8 8 0 0 0-.332-.722.08.08 0 0 1 0-.082l.677-.624a1.26 1.26 0 0 0 0-1.868l-1.5-1.383a1.56 1.56 0 0 0-2.029 0l-.677.624a.1.1 0 0 1-.094 0 8 8 0 0 0-.751-.28.07.07 0 0 1-.053-.068v-.89a1.38 1.38 0 0 0-1.435-1.322h-2.145a1.38 1.38 0 0 0-1.433 1.322v.936a.08.08 0 0 1-.056.068 7 7 0 0 0-.73.28.09.09 0 0 1-.094 0l-.718-.661a1.48 1.48 0 0 0-1.014-.385 1.5 1.5 0 0 0-1.014.385l-1.527 1.371a1.247 1.247 0 0 0 0 1.868l.71.624a.07.07 0 0 1 0 .086 6 6 0 0 0-.312.68.08.08 0 0 1-.074.049h-.961a1.5 1.5 0 0 0-1.03.4 1.26 1.26 0 0 0-.4.962v1.955a1.39 1.39 0 0 0 1.433 1.327h.966a.09.09 0 0 1 .076.051 7 7 0 0 0 .312.71.08.08 0 0 1 0 .086l-.677.624a1.247 1.247 0 0 0 0 1.868l1.5 1.39a1.533 1.533 0 0 0 2.029 0l.677-.624a.08.08 0 0 1 .089 0 8 8 0 0 0 .812.311.08.08 0 0 1 .048.068v.829a1.38 1.38 0 0 0 1.433 1.32h2.13a1.376 1.376 0 0 0 1.387-1.32v-.81a.07.07 0 0 1 .053-.068c.276-.093.555-.2.824-.318a.09.09 0 0 1 .089 0l.629.579a1.52 1.52 0 0 0 2.029 0l1.509-1.39a1.26 1.26 0 0 0 0-1.868l-.637-.579a.08.08 0 0 1 0-.079 6 6 0 0 0 .337-.761.08.08 0 0 1 .061-.03Zm-7.243 2.235a4.95 4.95 0 0 1-4.555-2.8 4.28 4.28 0 0 1 1.07-4.947 5.24 5.24 0 0 1 5.369-.988 4.55 4.55 0 0 1 3.043 4.195 4.753 4.753 0 0 1-4.93 4.54Zm3.578-4.54a3.31 3.31 0 0 1-2.209 3.046 3.81 3.81 0 0 1-3.9-.715 3.11 3.11 0 0 1-.776-3.592 3.59 3.59 0 0 1 3.3-2.032 3.74 3.74 0 0 1 2.531.965 3.17 3.17 0 0 1 1.047 2.329Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e5e5e5",
    transform: "translate(0 174)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 438,
    height: 145,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 437,
    height: 144,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  }))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 12,
    fontWeight: 600,
    transform: "translate(12 194)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "resQ Statistics"))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f4",
    d: "M395 206h1v89h-1zM427 206h1v89h-1zM364 206h1v89h-1zM333 206h1v89h-1zM302 206h1v89h-1zM272 206h1v89h-1zM242 206h1v89h-1zM212 206h1v89h-1zM182 206h1v89h-1zM153 206h1v89h-1zM126 206h1v89h-1z"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(121.001 214.001)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -81,
    y: 0
  }, "Filter by Country"))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f48641",
    d: "M127 206.839h78.9v5.769H127Z"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(211 212.478)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "13"))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed5b58",
    d: "M127.031 214.41h140.333v5.769H127.031Z"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(274.733 220.049)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "38"))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f48641",
    d: "M127.037 229.192h210.44v5.769h-210.44Z"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(343.934 234.831)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "109"))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed5b58",
    d: "M126.983 236.763h196.729v5.769H126.983Z"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(330.067 242.402)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "67"))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f48641",
    d: "M126.98 253.349h187.992v5.769H126.98Z"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(321.999 259.001)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "74"))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed5b58",
    d: "M126.993 260.92h224.693v5.769H126.993Z"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(359 266.001)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "345"))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#f48641",
    d: "M127.009 274.98h269.478v5.769H127.009Z"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(402.999 279.999)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "421"))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed5b58",
    d: "M127 282.552h280.53v5.769H127Z"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(414 288)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "460"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(119 237)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -74.88,
    y: 0
  }, "Filter by Device"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(120 260)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -54.03,
    y: 0
  }, "resQ Score"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(120 281)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -113.28,
    y: 0
  }, "Duplicate IP Restriction"))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#f48641",
    d: "M176 307.001h5v2h-5z"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 5,
    transform: "translate(186 310)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Filtered Out"))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed5b58",
    d: "M224.999 307.001h5v2h-5z"
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 5,
    transform: "translate(235 310)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Qualified"))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(126 300.001)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0"))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(149.999 300.001)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "50"))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(177.999 300.001)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "100"))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(207.001 300.001)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "150"))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(236 300.001)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "200"))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(267 300.001)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "250"))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(296.999 300.001)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "300"))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(327.999 300.001)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "350"))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(359 300.001)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "400"))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(390 300.001)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "450"))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7,
    transform: "translate(421 300.001)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "500"))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    fillRule: "evenodd",
    d: "M422.918 181.94h-3.555a.715.715 0 0 0-.711.711v7.111a.715.715 0 0 0 .711.711h7.111a.715.715 0 0 0 .711-.711v-3.555h.94v3.556a1.655 1.655 0 0 1-1.652 1.652h-7.11a1.655 1.655 0 0 1-1.652-1.652v-7.111a1.655 1.655 0 0 1 1.652-1.652h3.555zm4.27 2.069h.94v-2.539a.47.47 0 0 0-.47-.47h-2.542v.94h1.4l-3.928 3.937.665.665 3.935-3.937Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed5b58",
    d: "M0 179a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M0 80h920v52H0z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 57)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 35,
    fill: "#ea595b",
    rx: 5,
    transform: "translate(-8 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.004 39.004a11 11 0 1 0 11 11 11 11 0 0 0-11-11m-.755 14.62a.42.42 0 0 1-.418.419H7.99a.42.42 0 0 1-.418-.419V46.38a.42.42 0 0 1 .418-.418h1.837a.42.42 0 0 1 .418.418Zm4.183 0a.42.42 0 0 1-.418.419h-1.841a.42.42 0 0 1-.418-.419V46.38a.42.42 0 0 1 .418-.418h1.837a.42.42 0 0 1 .418.418Z"
  }))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    fill: "#989898",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(175.901 121)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Filter by Device"))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M166.334 116.575a.893.893 0 0 0-.893.894v3.954h4.067v-3.953a.894.894 0 0 0-.894-.894zm1.187 5.83a.3.3 0 1 1-.3.3.3.3 0 0 1 .3-.3m-.1-10.037h-10.526a.9.9 0 0 0-.895.895v6.007h8.438a.3.3 0 1 1 0 .6H156v1.042a.9.9 0 0 0 .895.9h4.189v.949h-1.189a.3.3 0 1 0 0 .6h4.524a.3.3 0 1 0 0-.6h-1.191v-.949h1.8v-4.342a1.306 1.306 0 0 1 1.266-1.306h2.021v-2.9a.9.9 0 0 0-.895-.895Zm-1.98 9.652v.438a.894.894 0 0 0 .895.894h2.278a.894.894 0 0 0 .894-.894v-.438h-4.068Z"
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    fill: "#ed5b5a",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(288.006 121)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "resQ Score"))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    fill: "#ed5b5a",
    fontFamily: "HonestJohns, Honest Johns",
    fontSize: 12,
    transform: "translate(268.105 120.471)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#989898"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(379.227 121)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Restrict Duplicate IP")), /*#__PURE__*/React.createElement("path", {
    d: "M367.764 122.809h-.513c-.28.3-.538.562-.741.761a.75.75 0 0 1-.52.211.73.73 0 0 1-.52-.213c-.2-.2-.459-.455-.741-.759h-.516c-.716.128-1.179.333-1.179.564 0 .392 1.323.71 2.955.71s2.955-.317 2.955-.71c.001-.234-.462-.434-1.18-.564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.755 123.278a.336.336 0 0 0 .473 0c.757-.739 3.069-3.115 3.069-4.644a3.305 3.305 0 0 0-6.61 0c-.003 1.528 2.311 3.907 3.068 4.644m-1.539-4.788a1.775 1.775 0 1 1 1.776 1.776 1.777 1.777 0 0 1-1.776-1.776M361.345 112.283a.242.242 0 1 0 .242.242.24.24 0 0 0-.242-.242M363.025 112.283a.242.242 0 1 0 .242.242.24.24 0 0 0-.242-.242M370.35 112.362H366a.163.163 0 1 0 0 .325h4.349a.163.163 0 0 0 0-.325Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.467 111.238h-8.954a1.83 1.83 0 0 0-1.829 1.829v.544h12.61v-.544a1.825 1.825 0 0 0-1.827-1.829m-9.123 1.932a.646.646 0 1 1 .645-.647.647.647 0 0 1-.645.647m1.68 0a.646.646 0 1 1 .645-.647.647.647 0 0 1-.644.647Zm7.33-.079H366a.567.567 0 0 1 0-1.135h4.354a.567.567 0 0 1 0 1.135M359.684 119.029a1.83 1.83 0 0 0 1.827 1.831h1.643a4.4 4.4 0 0 1-.877-2.224 3.709 3.709 0 0 1 7.418 0 4.4 4.4 0 0 1-.877 2.224h1.648a1.83 1.83 0 0 0 1.827-1.831v-5.015h-12.609Zm10.515-4.309a.2.2 0 0 1 .2-.2h.524a.615.615 0 0 1 0 1.23h-.323v.475a.203.203 0 1 1-.406 0v-1.5Zm-.82 0a.203.203 0 1 1 .406 0v1.5a.203.203 0 1 1-.406 0Zm-8.778-.27h1.9a.203.203 0 1 1 0 .406h-1.9a.203.203 0 1 1 0-.406m0 .678h1.19a.203.203 0 0 1 0 .406h-1.19a.203.203 0 0 1 0-.406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.137 115.133a.21.21 0 0 0-.211-.211h-.323v.422h.323a.21.21 0 0 0 .211-.211"
  }))), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 15,
    fontWeight: 700,
    transform: "translate(48 101)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "McDonalds Survey"))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    fill: "#6c6c6c",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(48 124)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ASDF1234"))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M129.474 112a6.016 6.016 0 1 0 6.016 6.016 6.017 6.017 0 0 0-6.016-6.016m-.7 8.613v-2.754a.7.7 0 0 1 1.39 0v2.754a.7.7 0 1 1-1.39 0m.7-4.208a.836.836 0 1 1 .836-.836.836.836 0 0 1-.836.836"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#e4f4e4",
    stroke: "#4baf4b",
    transform: "translate(197 91)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 14,
    stroke: "none",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 13,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 1.5
  }))), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    fill: "#4baf4b",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(202 102)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Live"))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 13,
    fontWeight: 300,
    transform: "translate(773.549 109)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Refresh Dashboard"))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    fillRule: "evenodd",
    d: "M757.636 97.121a7.379 7.379 0 1 0 7.379 7.379 7.387 7.387 0 0 0-7.379-7.379m0 3.162a4.22 4.22 0 0 1 3.568 1.969.527.527 0 0 1-.891.563 3.163 3.163 0 0 0-5.509.28l.6-.2a.527.527 0 1 1 .333 1l-1.581.527a.53.53 0 0 1-.666-.333l-.527-1.581a.527.527 0 0 1 1-.333l.055.163a4.22 4.22 0 0 1 3.618-2.055m3.6 4.219a.526.526 0 0 1 .551.358l.527 1.581a.527.527 0 1 1-1 .333l-.046-.139a4.217 4.217 0 0 1-7.454-.347.527.527 0 1 1 .954-.448 3.164 3.164 0 0 0 5.727.005l-.624.208a.527.527 0 0 1-.333-1l1.581-.527a.5.5 0 0 1 .115-.024Z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#f05a5c",
    transform: "translate(635 99.289)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.616,
    cy: 2.616,
    r: 2.616,
    transform: "translate(4.368 3.769)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.789 1.695a.11.11 0 0 0 .092-.051L4.519.612A1.29 1.29 0 0 1 5.619 0h2.734a1.29 1.29 0 0 1 1.1.612l.638 1.032a.11.11 0 0 0 .092.051h2.107a1.68 1.68 0 0 1 1.682 1.681V9.31a1.68 1.68 0 0 1-1.682 1.682H1.682A1.68 1.68 0 0 1 0 9.31V3.376a1.68 1.68 0 0 1 1.682-1.681Zm3.2 1.158a3.532 3.532 0 1 1-3.532 3.532 3.533 3.533 0 0 1 3.528-3.531Zm4.893 0a.819.819 0 1 1-.819.819.82.82 0 0 1 .815-.818Z"
  }))), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 13,
    fontWeight: 300,
    transform: "translate(657.676 109)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Screenshot"))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M919.744 104.766a1.561 1.561 0 1 1-1.561-1.561 1.56 1.56 0 0 1 1.561 1.561m-1.562-8.091a1.561 1.561 0 1 0 1.561 1.561 1.56 1.56 0 0 0-1.561-1.561m0 13.058a1.561 1.561 0 1 0 1.561 1.561 1.56 1.56 0 0 0-1.561-1.561"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e5e5e5",
    transform: "translate(446 174)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273,
    height: 145,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 144,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  }))), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 12,
    fontWeight: 600,
    transform: "translate(458 194)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Filter by Country"))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    fillRule: "evenodd",
    d: "M707.918 181.94h-3.555a.715.715 0 0 0-.711.711v7.111a.715.715 0 0 0 .711.711h7.111a.715.715 0 0 0 .711-.711v-3.555h.94v3.556a1.655 1.655 0 0 1-1.652 1.652h-7.11a1.655 1.655 0 0 1-1.652-1.652v-7.111a1.655 1.655 0 0 1 1.652-1.652h3.555zm4.27 2.069h.94v-2.539a.47.47 0 0 0-.47-.47h-2.542v.94h1.4l-3.928 3.937.665.665 3.935-3.937Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#655991",
    d: "M446 179a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5z"
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(496 227)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -35.24,
    y: 0
  }, "Nigeria"))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#877ea7",
    d: "M645.999 212h65v22h-65z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#655991",
    d: "M502.999 212h142.809v21.733H502.999Z"
  })), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(574.999 226)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.64,
    y: 0
  }, "158"))), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(678.999 227)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.575,
    y: 0
  }, "100"))), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(497 257)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -43.92,
    y: 0
  }, "Australia"))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#877ea7",
    d: "M639 242h72v22h-72z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#655991",
    d: "M503 242.001h136.09v21.595H503Z"
  })), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(571 256.001)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.14,
    y: 0
  }, "308"))), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(675 256.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.95,
    y: 0
  }, "115"))), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(496.999 287)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.65,
    y: 0
  }, "India"))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#877ea7",
    d: "M614 272.001h97v22h-97z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#655991",
    d: "M503.23 272.114h111.14v21.67H503.23Z"
  })), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(662.5 286.501)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.585,
    y: 0
  }, "150"))), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(558.801 286.449)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.58,
    y: 0
  }, "169"))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#655991",
    d: "M516.999 303h8v5h-8z"
  })), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 8,
    transform: "translate(528 307.999)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Qualified "))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#877ea7",
    d: "M591 303h8v5h-8z"
  })), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 8,
    transform: "translate(602 307.999)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Disqualified"))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e5e5e5",
    transform: "translate(0 327)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 241,
    height: 153,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 152,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  }))), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 12,
    fontWeight: 600,
    transform: "translate(12 347)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Restrict Duplicate IP"))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    fillRule: "evenodd",
    d: "M227.918 334.94h-3.555a.715.715 0 0 0-.711.711v7.111a.715.715 0 0 0 .711.711h7.111a.715.715 0 0 0 .711-.711v-3.555h.94v3.556a1.655 1.655 0 0 1-1.652 1.652h-7.11a1.655 1.655 0 0 1-1.652-1.652v-7.111a1.655 1.655 0 0 1 1.652-1.652h3.555zm4.27 2.069h.94v-2.539a.47.47 0 0 0-.47-.47h-2.542v.94h1.4l-3.928 3.937.665.665 3.935-3.937Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b5879",
    d: "M0 332a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#f16f4e",
    d: "M73.272 367.609c.63.008.84-.005 1.109 0a50.367 50.367 0 0 1 21.8 95.26 1 1 0 0 1-1.354-.457l-21.456-44.447s-.728-50.365-.099-50.356"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c5879",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M92.784 465.101a1 1 0 0 1-.486 1.344 50.367 50.367 0 0 1-70.26-55.973 1 1 0 0 1 1.2-.774l48.131 10.933Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#f16f4e",
    d: "M25.252 406.982a1 1 0 0 1-.748-1.218A50.37 50.37 0 0 1 72.28 367.61c.269-.006.893-.019 1.6 0s-.405.7-.5 50.354Z"
  })), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(78.312 406.145)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "59%"))), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(42.943 443.812)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "41%"))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(133.876 395.6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "#f16f4e",
    rx: 4,
    transform: "translate(0 5)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 12,
    transform: "translate(14 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Unique IP\u2019s")))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(133.876 422.6)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 12,
    transform: "translate(14 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Duplicate IP\u2019s")), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "#3b5879",
    rx: 4,
    transform: "translate(0 5)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e5e5e5",
    transform: "translate(249 327)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 398,
    height: 153,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 397,
    height: 152,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  }))), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 12,
    fontWeight: 600,
    transform: "translate(261 347)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Filter by Device"))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    fillRule: "evenodd",
    d: "M636.418 334.94h-3.555a.715.715 0 0 0-.711.711v7.111a.715.715 0 0 0 .711.711h7.111a.715.715 0 0 0 .711-.711v-3.555h.94v3.556a1.655 1.655 0 0 1-1.652 1.652h-7.11a1.655 1.655 0 0 1-1.652-1.652v-7.111a1.655 1.655 0 0 1 1.652-1.652h3.555zm4.27 2.069h.94v-2.539a.47.47 0 0 0-.47-.47h-2.542v.94h1.4l-3.928 3.937.665.665 3.935-3.937Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#655991",
    d: "M249 332a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5z"
  })), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(325.001 380)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.34,
    y: 0
  }, "PC"))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#40979d",
    d: "M597 364h45v27h-45z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c8389",
    d: "M334.456 364.213h262.741v26.958H334.456Z"
  })), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(436 379)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.065,
    y: 0
  }, "268"))), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(619 380)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.54,
    y: 0
  }, "16"))), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(318 413)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -56.64,
    y: 0
  }, "iPAD/Tablet"))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#40979e",
    d: "M535 397h107v26H535z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c8389",
    d: "M334.456 396.464H535.1v26.787H334.456Z"
  })), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(431 411)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.975,
    y: 0
  }, "200"))), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(585.199 411.805)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.815,
    y: 0
  }, "113"))), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(323 445)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.67,
    y: 0
  }, "Mobile"))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#40979e",
    d: "M552 429h90v27h-90z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c8389",
    d: "M335.185 428.854h216.834v26.88H335.185Z"
  })), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(596.364 444.056)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.57,
    y: 0
  }, "97"))), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 10,
    transform: "translate(442.296 443.992)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.58,
    y: 0
  }, "169"))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c8389",
    d: "M355 464h12v5h-12z"
  })), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 8,
    transform: "translate(372.001 468)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Qualified "))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#40979e",
    d: "M464.001 464h12v5h-12z"
  })), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 8,
    transform: "translate(480.001 468)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Disqualified"))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e5e5e5",
    transform: "translate(655 327)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 265,
    height: 153,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 152,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  }))), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 12,
    fontWeight: 600,
    transform: "translate(667 347)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "resQ Score"))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    fillRule: "evenodd",
    d: "M905.706 334.94h-3.555a.715.715 0 0 0-.711.711v7.111a.715.715 0 0 0 .711.711h7.111a.715.715 0 0 0 .711-.711v-3.555h.94v3.556a1.655 1.655 0 0 1-1.652 1.652h-7.11a1.655 1.655 0 0 1-1.652-1.652v-7.111a1.655 1.655 0 0 1 1.652-1.652h3.555zm4.27 2.069h.94v-2.539a.47.47 0 0 0-.47-.47h-2.542v.94h1.4l-3.928 3.937.665.665 3.935-3.937Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2558e",
    d: "M655 332a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#f16f4f",
    d: "M731.432 382.141a45.431 45.431 0 1 0 45.431 45.431 45.43 45.43 0 0 0-45.431-45.431m0 68.992a23.561 23.561 0 1 1 23.561-23.561 23.56 23.56 0 0 1-23.561 23.561"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#56619c",
    d: "m748.009 385.274-7.98 20.361a23.62 23.62 0 0 1 13.788 14.581l20.776-6.827a45.54 45.54 0 0 0-26.584-28.115"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#be568a",
    d: "M776.862 427.571a45.4 45.4 0 0 0-2.27-14.182l-20.776 6.827a23.565 23.565 0 0 1-17.691 30.447l4.356 21.434a45.444 45.444 0 0 0 36.381-44.526"
  })), _text70 || (_text70 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(703.7 450.474)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.31,
    y: 0
  }, "32%"))), _text71 || (_text71 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(757.312 406.245)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.01,
    y: 0
  }, "13%"))), _text72 || (_text72 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(761.921 446.243)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.59,
    y: 0
  }, "30%"))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#288c8d",
    d: "M734.148 382.218a45.4 45.4 0 0 1 14.015 3.13l-8.083 20.32a23.5 23.5 0 0 0-7.268-1.624 23.365 23.365 0 0 0-22.797 13.789l-20.488-7.81c5.703-14.854 22.674-29.147 44.62-27.805"
  })), _text73 || (_text73 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(718.719 398.746)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.46,
    y: 0
  }, "25%"))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(788.531 389.6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "#f58840",
    rx: 3.5,
    transform: "translate(0 2)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 9,
    transform: "translate(12.25 9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Inorganic")))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(788.531 408.6)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 9,
    transform: "translate(12.251 9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Least Organic")), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "#26928f",
    rx: 3.5,
    transform: "translate(0 2)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(788.531 428.6)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 9,
    transform: "translate(12.251 9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Moderately Organic")), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "#4c66a1",
    rx: 3.5,
    transform: "translate(0 2)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(788.531 447.6)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#343434",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 9,
    transform: "translate(12.251 9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Organic")), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "#b2558e",
    rx: 3.5,
    transform: "translate(0 3)"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M3 0h919v74H3z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M3 75h919v1H3z"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#eaeaea",
    transform: "translate(665.238 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m698.426 35.128-.361-.874c1.237-2.853 1.156-2.938.914-3.182l-1.58-1.576-.157-.136h-.182c-.1 0-.384 0-2.788 1.112l-.885-.365c-1.143-2.892-1.26-2.892-1.599-2.892h-2.226c-.335 0-.465 0-1.523 2.9l-.88.365a15 15 0 0 0-2.833-1.059h-.212l-1.695 1.694c-.261.265-.352.352.957 3.161l-.361.872c-2.896 1.145-2.896 1.255-2.896 1.614v2.223c0 .35 0 .473 2.9 1.536l.361.87c-1.237 2.853-1.154 2.938-.914 3.182l1.581 1.578.157.138h.185c.1 0 .38 0 2.786-1.114l.883.367c1.144 2.887 1.26 2.887 1.606 2.887h2.221c.342 0 .462 0 1.525-2.9l.885-.365a15 15 0 0 0 2.828 1.061h.212l1.717-1.71c.244-.25.329-.337-.972-3.136l.359-.872c2.9-1.154 2.9-1.275 2.9-1.623V36.66c-.004-.345-.004-.473-2.913-1.532m-7.7 6.4a3.713 3.713 0 1 1 3.7-3.711 3.713 3.713 0 0 1-3.7 3.711"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#dedede",
    transform: "translate(284.581 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 50,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    fillRule: "evenodd",
    d: "M318.269 42.176a8.03 8.03 0 1 1 .988-.988l5.165 5.163a.7.7 0 0 1-.988.988Zm0-1.979a6.634 6.634 0 1 0-.987.987 6.7 6.7 0 0 0 .987-.987"
  })), _text74 || (_text74 = /*#__PURE__*/React.createElement("text", {
    fill: "#b1b1b1",
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 12,
    fontWeight: 300,
    transform: "translate(388.581 43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -50.61,
    y: 0
  }, "Search with data"))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(785 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 50,
    fill: "#ebebeb",
    rx: 10
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 14,
    fontWeight: 300,
    transform: "translate(53 22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Richard ")), /*#__PURE__*/React.createElement("text", {
    fill: "#7e7e7e",
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 12,
    fontWeight: 300,
    transform: "translate(53 38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Director")), /*#__PURE__*/React.createElement("path", {
    d: "M123.888 28.076a.66.66 0 0 1-.45-.18l-6.085-5.776a.65.65 0 1 1 .893-.943l5.641 5.353 5.638-5.353a.65.65 0 1 1 .894.943l-6.082 5.776a.65.65 0 0 1-.45.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a2a2a2",
    fillRule: "evenodd",
    d: "M40.368 3.998a6.14 6.14 0 0 1 6.138 6.138v30.33a6.14 6.14 0 0 1-6.138 6.138H10.04a6.14 6.14 0 0 1-6.14-6.138V10.139a6.14 6.14 0 0 1 6.14-6.141Zm-10.595 20.94a14.97 14.97 0 0 1 9.744 10.124v.005a3.97 3.97 0 0 1-3.826 5.037c-5.281 0-15.7 0-20.983-.043a3.93 3.93 0 0 1-3.776-4.981 14.85 14.85 0 0 1 9.7-10.142 7.943 7.943 0 1 1 9.137 0ZM25.2 26.384a12.65 12.65 0 0 0-12.181 9.274 1.762 1.762 0 0 0 1.7 2.234h.009c5.278.043 15.689.043 20.967.043a1.806 1.806 0 0 0 1.741-2.288 12.744 12.744 0 0 0-12.228-9.265Zm0-2.167a5.777 5.777 0 1 0-5.777-5.777 5.78 5.78 0 0 0 5.777 5.777"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#eaeaea",
    transform: "translate(725.169 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "#f05a5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M759.972 44.604a1.42 1.42 0 0 1-1.412 1.415h-16.788a1.4 1.4 0 0 1-1.415-1.339 3.5 3.5 0 0 1 3.2-3.561v-4.412a6.6 6.6 0 0 1 6.52-6.627h.139a6.6 6.6 0 0 1 6.563 6.627v4.412a3.5 3.5 0 0 1 3.193 3.485M751.807 48.427h-3.279a.67.67 0 1 1 0-1.339h3.279a.67.67 0 1 1 0 1.339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.168 31.208a.67.67 0 0 1-.67-.661v-1.675a.67.67 0 0 1 1.339 0v1.674a.67.67 0 0 1-.669.662"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#resQ_Slider3_svg__c)",
    style: {
      isolation: "isolate"
    },
    transform: "translate(3.472 55.524)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#resQ_Slider3_svg__g)",
    style: {
      isolation: "isolate"
    },
    transform: "translate(.999 1)"
  }, _text75 || (_text75 = /*#__PURE__*/React.createElement("text", {
    fill: "#8b8c8f",
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 7,
    fontWeight: 700,
    letterSpacing: ".092em",
    transform: "translate(0 6.573)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Target Right, Gain Insight"))))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "M12.232 27.218a13.8 13.8 0 0 1 3.461-5.588 7.08 7.08 0 0 1 4.835-1.788 3 3 0 0 1 .467.028 3 3 0 0 0 .412.028 16 16 0 0 0-.247 1.76q-.082.935-.082 2.2v2.7a8 8 0 0 0 .055.935l-.495.44a6 6 0 0 0-1.236-.55 5.1 5.1 0 0 0-1.566-.22 4.93 4.93 0 0 0-3.9 1.623 5.6 5.6 0 0 0-1.429 3.823v2.2q0 3.355.082 6.326t.357 5.721a12 12 0 0 0-1.786-.11H6.517a13 13 0 0 0-1.813.11q.275-2.75.357-5.721t.082-6.326v-2.2q0-3.355-.082-6.3t-.357-5.912q.934.11 1.9.193t1.9.083 1.9-.083 1.9-.193l-.165 6.711Zm20.5 6.491a18.5 18.5 0 0 0 .432 4.121 10.3 10.3 0 0 0 1.346 3.328 6.6 6.6 0 0 0 2.308 2.2 6.5 6.5 0 0 0 3.269.8 10.26 10.26 0 0 0 6.758-2.475l.659.5-1.205 3.077a11.2 11.2 0 0 1-3.3 1.678 16.6 16.6 0 0 1-5.055.633 17.3 17.3 0 0 1-5.11-.743 10.9 10.9 0 0 1-4.256-2.448 12 12 0 0 1-2.914-4.318 16.4 16.4 0 0 1-1.071-6.243 18.2 18.2 0 0 1 .962-6.216 12.3 12.3 0 0 1 2.665-4.4 10.9 10.9 0 0 1 4.039-2.64 14.3 14.3 0 0 1 5.083-.88q5.44 0 8.324 3.19t2.885 9.021v1.155a2.5 2.5 0 0 1-.055.66Zm8.457-2.479a21.3 21.3 0 0 0-1.017-6.6q-.907-2.475-3.05-2.475a2.76 2.76 0 0 0-2.033.825 6 6 0 0 0-1.319 2.118 14 14 0 0 0-.742 2.915 28 28 0 0 0-.3 3.218Zm12.857 8.856a8.5 8.5 0 0 0 .852 1.678 6.4 6.4 0 0 0 1.291 1.43 6.1 6.1 0 0 0 1.841 1.018 7.4 7.4 0 0 0 2.5.385 4.14 4.14 0 0 0 2.967-.99 2.93 2.93 0 0 0 1.044-2.145 2.5 2.5 0 0 0-.934-2.035 10.4 10.4 0 0 0-2.335-1.4q-1.4-.633-3.05-1.293a14 14 0 0 1-3.05-1.678 8.7 8.7 0 0 1-2.335-2.558 7.55 7.55 0 0 1-.934-3.96 8.7 8.7 0 0 1 .852-3.988 8.05 8.05 0 0 1 2.225-2.75 9.4 9.4 0 0 1 3.1-1.6 11.8 11.8 0 0 1 3.434-.523 11.8 11.8 0 0 1 4.094.66 17.2 17.2 0 0 1 3.656 1.93 15 15 0 0 0-.822 2.363 21 21 0 0 0-.495 2.475h-1.538a7.7 7.7 0 0 0-.545-1.455 6.2 6.2 0 0 0-1.044-1.513 5.5 5.5 0 0 0-1.593-1.183 5 5 0 0 0-2.253-.468 4.37 4.37 0 0 0-2.775.88 2.79 2.79 0 0 0-1.126 2.31 2.61 2.61 0 0 0 .962 2.118 9.6 9.6 0 0 0 2.39 1.4q1.429.605 3.132 1.21a14 14 0 0 1 3.132 1.568 8.2 8.2 0 0 1 2.39 2.5 7.37 7.37 0 0 1 .962 3.96 9.1 9.1 0 0 1-.879 4.153 8.2 8.2 0 0 1-2.363 2.86 9.5 9.5 0 0 1-3.385 1.63 15.7 15.7 0 0 1-3.984.5 13 13 0 0 1-4.451-.715 14.8 14.8 0 0 1-3.131-1.49 29.3 29.3 0 0 0 .824-5.281Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#resQ_Slider3_svg__h)",
    d: "M108.812 20.656c-.551-3.812 3.176-7.239 7.9-4.152 4.584 7.835 2.717 13.468 0 21.278 3.756 3.784 3.529 3.125 6.2 6.346.6 3.67-.843 7.224-6.731 5.646-3.9-4.138-.906-.906-4.99-5.183-11.876 7.527-31.6 7.639-36.82-12.747C73.549 22 75.269 7.75 95.754 4.679c9.155-.9 7.839 9.2 1.959 8.965-2.29-.214-14.539 2.436-14.524 11.956s7.683 16.088 14.523 15.088 15.271-6.32 11.1-20.032",
    transform: "translate(3 1)"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#ebebeb",
    transform: "translate(605.307 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M628.617 38.357a6.7 6.7 0 0 0-1.586 1.166c-.464.414-2.5 2.644-3.2 3.482-1.007 1.214-.959 1.14-1.068-.339-.028-.383-.1-.761-.145-1.142-.064-.5-.243-.933-.763-1-.848-.109-1.548.082-1.548.8 0 1.869.209 3.619.37 5.514.028.332.013.75.281.986.335.287 1.211.188 1.742.163a29 29 0 0 0 4.708-.494c.745-.205.74-.812.7-1.42-.018-.271-.191-.806-.636-.827-.679-.032-1.4-.008-1.953 0-.445.006-.591-.042.181-.819 1.1-1.105 2.277-2.173 3.27-3.374a3.16 3.16 0 0 0 .817-1.271c.115-.654-.377-1.725-1.17-1.425m12.214-11.108c-.216-.265-.657-.36-2.81-.076a25.5 25.5 0 0 1-3.837.249c-.642-.013-.9.776-.938 1.289a.77.77 0 0 0 .241.677 2.7 2.7 0 0 0 1.262.274c.453.046.908.063 1.361.1-.558.626-1.306 1.527-1.566 1.818-.8.888-1.36 1.565-2.133 2.473-.387.454-1.011 1.057-.752 1.712a1.143 1.143 0 0 0 1.476.558 13 13 0 0 0 2.056-1.7c.64-.619 1.092-1.191 1.7-1.844.317-.342.678-.806 1.05-1.159l.125 1.532c.1 1.174.842 1.2 1.579 1.177.546-.014.787-.385.914-1 .107-.516.168-2.744.307-4.219.041-.496.201-1.568-.035-1.861M632.646 38.357a6.7 6.7 0 0 1 1.59 1.166c.464.414 2.5 2.644 3.2 3.482 1.007 1.214.959 1.14 1.068-.339.028-.383.1-.761.145-1.142.064-.5.243-.933.763-1 .848-.109 1.548.082 1.548.8 0 1.869-.209 3.619-.37 5.514-.028.332-.013.75-.281.986-.335.287-1.211.188-1.742.163a29 29 0 0 1-4.708-.494c-.745-.205-.74-.812-.7-1.42.018-.271.191-.806.636-.827.679-.032 1.4-.008 1.953 0 .445.006.591-.042-.181-.819-1.1-1.105-2.277-2.173-3.27-3.374a3.16 3.16 0 0 1-.817-1.271c-.119-.654.373-1.725 1.166-1.425m-12.215-11.108c.216-.265.657-.36 2.81-.076a25.5 25.5 0 0 0 3.837.249c.642-.013.9.776.938 1.289a.77.77 0 0 1-.241.677 2.7 2.7 0 0 1-1.262.274c-.453.046-.908.063-1.361.1.558.626 1.306 1.527 1.566 1.818.8.888 1.36 1.565 2.133 2.473.387.454 1.011 1.057.752 1.712a1.143 1.143 0 0 1-1.476.558 13 13 0 0 1-2.056-1.7c-.64-.619-1.092-1.191-1.7-1.844-.317-.342-.678-.806-1.05-1.159l-.125 1.532c-.1 1.174-.842 1.2-1.579 1.177-.546-.014-.787-.385-.914-1-.107-.516-.168-2.744-.307-4.219-.04-.496-.2-1.568.035-1.861"
  })));
};
export default SvgResQSlider3;